// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UstO_","content":"styles_content__1xdLy","tableWrap":"styles_tableWrap__2AjQn"};